export const MOCKUP_URL =
  'https://cdn.magicpatterns.com/uploads/so6AaYWAEKPbLXCqa8XZZn/Mockup.png'
